module.exports = __webpack_public_path__ + "img/cargo-dispute-photo-guide.5ceae18c.png";